import { isObject } from "../is.js";
import { eachElements } from "./utils.js";
function setStyles(elementOrElements, styles, method = "add") {
  if (!elementOrElements || !styles || !isObject(styles)) {
    return;
  }
  eachElements(elementOrElements, (el) => {
    for (const [prop, value] of Object.entries(styles)) {
      el.style[prop] = method === "add" ? value : "";
    }
  });
}
function add(elementOrElements, styles) {
  setStyles(elementOrElements, styles);
}
function remove(elementOrElements, styles) {
  setStyles(elementOrElements, styles, "remove");
}
export {
  add,
  remove
};
//# sourceMappingURL=styles.js.map
